import type { I18nTranslateFunction } from 'i18n';
import { Chip, GridColDef } from 'ui';

import { SelectedInspector } from '../../types';

type Translate = I18nTranslateFunction<string>;

export const getColumns = (t: Translate): GridColDef<SelectedInspector>[] => [
  {
    field: 'name',
    flex: 1,
    headerName: t('inspectionCompany.fields.name'),
  },
  {
    field: 'Company',
    flex: 1,
    headerName: t('inspectionCompany.fields.company'),
    valueGetter: (_value, row) => {
      if (!row?.company) {
        return t('inspectionCompany.values.notAvailable');
      }
      return String(row.company.name);
    },
  },
  {
    field: 'is_active',
    flex: 1,
    headerName: t('inspectionCompany.fields.status'),
    renderCell: (params) => {
      return (
        <Chip
          color={params.value ? 'success' : 'error'}
          variant="outlined"
          label={params.value ? t('inspectionCompany.status.active') : t('inspectionCompany.status.inactive')}
        />
      );
    },
  },
  {
    field: 'email',
    flex: 1,
    headerName: t('inspectionCompany.fields.email'),
  },
  {
    field: 'phone_number',
    flex: 1,
    headerName: t('inspectionCompany.fields.phoneNumber'),
  },
];
